import { Controller } from "@hotwired/stimulus"

// Phase 2.12 Tier 4 — inline toggle for AI tile narratives in the
// portfolio dashboard settings dropdown. PATCHes directly to
// companies#update_portfolio_settings; no modal, no live preview.
export default class extends Controller {
  static targets = ["checkbox"]
  static values = { url: String }

  async save() {
    const enabled = this.checkboxTarget.checked
    const body = new FormData()
    body.append("tile_narratives_enabled", enabled ? "1" : "0")

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          Accept: "application/json"
        },
        body
      })
      const data = await response.json()
      if (!response.ok || !data.success) {
        this.checkboxTarget.checked = !enabled
        this._toast((data.errors || ["Save failed"]).join(", "), "alert")
        return
      }
      this._toast(`AI tile narratives ${enabled ? "enabled" : "disabled"}`, "notice")
    } catch (e) {
      this.checkboxTarget.checked = !enabled
      this._toast("Network error", "alert")
    }
  }

  _toast(message, kind) {
    const klass = kind === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    const el = document.createElement("div")
    el.className = klass
    el.dataset.controller = "flash"
    el.dataset.flashDismissAfterValue = "5000"
    el.textContent = message
    document.body.prepend(el)
  }
}
